export const columns = [
  {
    title: 'Nombre',
    name: 'name'
  },
  {
    title: 'Usuario',
    name: 'username'
  },
  {
    title: 'Correo Eléctronico',
    name: 'email'
  },
  {
    title: 'Identificación',
    name: 'identification'
  },
  {
    title: 'Aliado',
    name: 'supplierName'
  },
  {
    title: 'Tiene lector biométrico',
    name: 'hasBiometricReader'
  },
  {
    title: 'Serial',
    name: 'serial'
  },
  {
    title: '¿Autenticación?',
    name: 'hasAutentication'
  },
  {
    title: 'Activación 2FA',
    name: 'hasAuthenticationEnabled'
  }
];

export const mapData = data =>
  data.map(datum => {
    return {
      ...datum,
      name: datum.firstName + ' ' + datum.lastName || '--',
      username: datum.username || '--',
      email: datum.email || '--',
      identification: datum.identification || '--',
      supplierName: datum.supplier ? datum.supplier.name : '--',
      hasBiometricReader: datum.hasBiometricReader ? 'SI' : 'NO',
      serial: datum.biometricReader ? datum.biometricReader.serial : '--',
      hasAutentication: datum.is2faPasskeyConfirmed ? 'SI' : 'NO',
      hasAuthenticationEnabled: datum.is2faEnabled ? 'SI' : 'NO'
    };
  });
